import { render } from "./ChatMessageElement.vue?vue&type=template&id=533796a0&scoped=true"
import script from "./ChatMessageElement.vue?vue&type=script&lang=js"
export * from "./ChatMessageElement.vue?vue&type=script&lang=js"

import "./ChatMessageElement.vue?vue&type=style&index=0&id=533796a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533796a0"]])

export default __exports__